import { useState } from 'react'
import { sanitizeImageUrl } from '../imageUrl'
import type { HoverCardProps } from '../Types'

const isIE = window?.siteVar?.referer === 'IE'

function HoverCard({ className = '', front, back }: HoverCardProps) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      className={`position-relative overflow-hidden ${className}`}
      style={{ height: 350 }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className="position-absolute top-0 start-0 end-0 bottom-0 bg-white d-flex flex-column justify-content-center align-items-center"
        style={{ opacity: hovered ? 1 : 0, transition: 'opacity 0.3s', zIndex: 2 }}
      >
        {back}
      </div>
      <div
        className="position-relative w-100 h-100"
        style={{ opacity: hovered ? 0 : 1, transition: 'opacity 0.3s', zIndex: 1 }}
      >
        {front}
      </div>
    </div>
  )
}

export default function WhyTrailfinders() {
  return (
    <section className="app-section app-section-grey container-fluid pt-5 px-4 px-md-0 pt-md-0">
      <div className="container pb-4 px-0">
        <div className="d-flex text-start pb-4 pt-0 py-md-5 px-0">
          <h4 className="fw-bold fs-5 fs-md-4 col p-0">Why Trailfinders?</h4>
          <a href="/contact" className="btn rounded-0 btn-lg col-2 col-md-3 d-none d-md-block bg-tf-orange text-white">
            <span>Enquire Now</span>
          </a>
        </div>

        <div className="column">

          <div className="row g-0 mb-2">
            <HoverCard className="col-12 col-md-6 pb-2 pb-md-0 pe-md-1"
              front={
                <>
                {isIE ? 
                (
                <>
                <img
                    src={sanitizeImageUrl('https://cdn.trailfinders.com/ireland_scene.jpg', { height: 350 })}
                    className="img-fluid w-100 h-100 d-block refererHide-UK"
                    style={{ objectFit: 'cover' }}
                    alt="Ireland Flights"
                  />
                  </>
                ) 
                : 
                (   
                <>
                 <img
                    src={sanitizeImageUrl('https://cdn.trailfinders.com/i18szckhsc_flights-london.jpg', { height: 350 })}
                    className="img-fluid w-100 h-100 d-block refererHide-IE"
                    style={{ objectFit: 'cover' }}
                    alt="UK Flights"
                  />
                </>
                ) 
                }
                 

                  <div className="position-absolute top-0 start-0 end-0 bottom-0 bg-black bg-opacity-50 d-flex justify-content-center align-items-center">
                    {isIE ? 
                    (<>
                    <p className="text-white fs-5 mb-0 refererHide-UK"><b>Ireland based support from a real person</b></p>
                    </>
                    )
                    :
                    (<>
                    <p className="text-white fs-5 mb-0 refererHide-IE"><b>UK based support from a real person</b></p>
                    </>
                    )
                    }
                  </div>
                </>
              }
              back={
                <ul className="list text-start p-5 gap-5">
                  <li className="dark">24/7/365 support from a real person, not a chat-bot. Often solving problems before you knew they existed.</li>
                  <li>Here for you before, during, and after travel.</li>
                  <li>The average flight booking is impacted by two schedule changes, which we manage for you without cost.</li>
                  <li>Advice regarding lost bags and flight delay compensation.</li>
                </ul>
              }
            />

            <HoverCard className="col-12 col-md-6 ps-md-1"
              front={
                <>
                  <img
                    src={sanitizeImageUrl('https://cdn.trailfinders.com/ks0brujtnz_flights-direction.jpg', { height: 350 })}
                    className="img-fluid w-100 h-100 d-block"
                    style={{ objectFit: 'cover' }}
                    alt=""
                  />
                  <div className="position-absolute top-0 start-0 end-0 bottom-0 bg-black bg-opacity-50 d-flex justify-content-center align-items-center">
                    <p className="text-white fs-5 mb-0"><b>Choice</b></p>
                  </div>
                </>
              }
              back={
                <ol className="list text-start p-5 gap-5">
                  <li>We compare flights on over 200 airlines, saving you time and money by searching the whole market.</li>
                  <li>We can offer a range of options including flexible tickets, student fares, corporate fares, one-way upgrades, stopovers, multi centre flights and round the world tickets, saving you time and enhancing your trip.</li>
                </ol>
              }
            />
          </div>

          <div className="row g-0 mb-2">
            <HoverCard className="col-12 col-md-12"
              front={
                <>
                  <img
                    src={sanitizeImageUrl('https://cdn.trailfinders.com/uhymzi97sm_flights-blue-scenery.jpg', { height: 350 })}
                    className="img-fluid w-100 h-100 d-block"
                    style={{ objectFit: 'cover' }}
                    alt=""
                  />
                  <div className="position-absolute top-0 start-0 end-0 bottom-0 bg-black bg-opacity-50 d-flex justify-content-center align-items-center">
                    <p className="text-white fs-5 mb-0"><b>Hassle free</b></p>
                  </div>
                </>
              }
              back={
                <ul className="list text-start p-5 gap-5">
                  <li className="dark">The average booking is impacted by 2 schedule changes. We address this without stress or cost to you.</li>
                  <li>We monitor your booking from the moment you book to the moment you return home, handling any changes or disruptions on your behalf.</li>
                  <li>All flights include at least 20kg of baggage, with no hidden fees.</li>
                </ul>
              }
            />
          </div>

          <div className="row g-0">
            <HoverCard className="col-12 col-md-6 pb-2 pb-md-0 pe-md-1"
              front={
                <>
                  <img
                    src={sanitizeImageUrl('https://cdn.trailfinders.com/h4ucr29lld_flights-compass.jpg', { height: 350 })}
                    className="img-fluid w-100 h-100 d-block"
                    style={{ objectFit: 'cover' }}
                    alt=""
                  />
                  <div className="position-absolute top-0 start-0 end-0 bottom-0 bg-black bg-opacity-50 d-flex justify-content-center align-items-center">
                    <p className="text-white fs-5 mb-0"><b>Expertise</b></p>
                  </div>
                </>
              }
              back={
                <ul className="list text-start p-5 gap-5">
                  <li className="dark">Trailfinders are rated No.1 for flights on Trustpilot.</li>
                  <li>Our well-travelled consultants have been to 99% of countries in the world, and have flown in virtually every cabin on every airline.</li>
                  <li className="d-none d-md-block">Our consultants have a wealth of information at their fingertips about airline seats, aircraft types and airport lounges, helping you to make an informed choice.</li>
                  <li className="d-none d-md-block">We have a team of dedicated first &amp; business class consultants available in all our travel centres.</li>
                </ul>
              }
            />

            <HoverCard className="col-12 col-md-6 ps-md-1"
              front={
                <>
                  <img
                    src={sanitizeImageUrl('https://cdn.trailfinders.com/ndpha0ap2l_flights-bank-safe.jpg', { height: 350 })}
                    className="img-fluid w-100 h-100 d-block"
                    style={{ objectFit: 'cover' }}
                    alt=""
                  />
                  <div className="position-absolute top-0 start-0 end-0 bottom-0 bg-black bg-opacity-50 d-flex justify-content-center align-items-center">
                    <p className="text-white fs-5 mb-0"><b>Financial Security</b></p>
                  </div>
                </>
              }
              back={
                <ol className="list text-start p-5 gap-5">
                  <li>Trailfinders pays for your flights and leaves your money untouched in an independent trust account until your flights are complete.</li>
                  <li>The Trailfinders Guarantee protects your money in the event of an airline failure. We've managed the failure of over 140 airlines in our history, at no cost to our clients.</li>
                </ol>
              }
            />
          </div>

        </div>
      </div>
    </section>
  )
}
